import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-hot-toast";
import Pagination from "../../components/pagination";
import Loader from "../../components/loader";
import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";
import { FaSortUp, FaSortDown } from "react-icons/fa";

export default () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState(null);
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
    limit: 30,
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
    endDate: new Date(),
    sortBy: "email",
    sortOrder: "ASC",
  });

  const [total, setTotal] = useState(1);

  const history = useHistory();

  useEffect(() => {
    getUsers();
  }, [filter]);

  async function getUsers() {
    try {
      const res = await api.post("/report", filter);
      if (!res.ok) return toast.error(res.error);
      setUsers(res.data);
      setTotal(res.total);
    } catch (error) {
      console.log(error);
    }
  }

  const exportToCsv = async () => {
    try {
      setLoading(true);
      filter.limit = 2000;
      const res = await api.post("/report", filter);
      if (!res.ok) return toast.error(res.error);
      const { data } = res;

      let csvContent = "data:text/csv;charset=utf-8,";
      const headers =
        "Email,Created at,Last login at,Code,Pauses,Tonus,Detente,Concentration,Total score,Good distance,Fatigability score\n";
      csvContent += headers;

      data.forEach((user) => {
        const row = `${user.email},${user.createdDate?.slice(0, 10)},${
          user.lastLoginAt
            ? new Date(parseInt(user.lastLoginAt)).toLocaleString()
            : "N/A"
        },${user.code},${user.Pauses},${user.Tonus},${user.Detente},${
          user.Concentration
        },${user.Score},${user.goodDistance === 1 ? "YES" : "NO"},${
          user.fatigabilityScore
        }\n`;
        csvContent += row;
      });

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "user_report.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    setFilter((prev) => ({
      ...prev,
      sortBy: field,
      sortOrder:
        prev.sortBy === field
          ? prev.sortOrder === "ASC"
            ? "DESC"
            : "ASC"
          : "ASC",
    }));
  };

  const SortButton = ({ field, children }) => {
    return (
      <button
        className="flex items-center gap-2"
        onClick={() => handleSort(field)}
      >
        {children}
        {(filter.sortBy === field && (
          <span className="flex flex-col gap-1">
            {filter.sortOrder === "DESC" && <FaSortUp />}
            {filter.sortOrder === "ASC" && <FaSortDown />}
          </span>
        )) || <FaSortDown className="text-gray-300" />}
      </button>
    );
  };

  if (!users) return <Loader />;

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row gap-5 items-center justify-between mb-10">
        <h3 className="text-xl font-bold shrink-0">Users</h3>
        <div className="flex items-center justify-end gap-x-2.5">
          {/* <DatePicker value={dateRange} onChange={setDateRange} /> */}
          <div className="w-full max-w-md relative">
            <input
              className="input"
              type="search"
              placeholder="Type here..."
              value={filter.search}
              onChange={(e) => {
                e.persist();
                setFilter((prev) => ({
                  ...prev,
                  search: e.target.value,
                  page: 1,
                }));
              }}
            />
          </div>

          <LoadingButton
            className="p-2.5 px-4 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 whitespace-nowrap"
            disabled={!users || loading}
            loading={loading}
            onClick={exportToCsv}
          >
            Export to CSV
          </LoadingButton>
        </div>
      </div>
      <div className="flow-root">
        <div className="overflow-x-auto">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden ring-1 ring-primary-black-50">
              <table className="min-w-full divide-y divide-primary-black-50">
                <thead className="bg-white text-sm text-left text-h3-semibold text-primary-black-100 whitespace-nowrap">
                  <tr>
                    <th className="p-3">Name</th>
                    <th className="p-3">
                      <SortButton field="email">Email</SortButton>
                    </th>
                    <th className="p-3">Total score</th>
                    <th className="p-3">Vitality index</th>
                    <th className="p-3">
                      <SortButton field="lastLoginAt">Last login at</SortButton>
                    </th>
                    <th className="p-3">Pauses</th>
                    <th className="p-3">Tonus</th>
                    <th className="p-3">Detente</th>
                    <th className="p-3">Concentration</th>
                    <th className="p-3">Good distance</th>
                    <th className="p-3">Teams</th>
                    <th className="p-3">Webapp</th>
                    <th className="p-3">
                      <SortButton field="code">Code</SortButton>
                    </th>
                    <th className="p-3">Notifications</th>
                    <th className="p-3">Created at</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-primary-black-50 bg-white text-sm text-primary-black-90 whitespace-nowrap">
                  {users.map((user) => (
                    <tr
                      key={user.userId}
                      className={`odd:bg-[#FCFCFC] hover:bg-black-10 cursor-pointer`}
                      onClick={() => history.push(`/user/${user.userId}`)}
                    >
                      <td className="p-3">
                        {user.firstName} {user.lastName}
                      </td>

                      <td className="p-3">{user.email}</td>
                      <td className="p-3 text-center">{user.Score}</td>
                      <td className="p-3 text-center">
                        {user.fatigabilityScore}
                      </td>
                      <td className="p-3">
                        {user.lastLoginAt
                          ? new Date(
                              parseInt(user.lastLoginAt)
                            ).toLocaleString()
                          : ""}
                      </td>
                      <td className="p-3 text-center">{user.Pauses}</td>
                      <td className="p-3 text-center">{user.Tonus}</td>
                      <td className="p-3 text-center">{user.Detente}</td>
                      <td className="p-3 text-center">{user.Concentration}</td>
                      <td className="p-3">
                        {user.goodDistance === 1 ? "YES" : "NO"}
                      </td>
                      <td className="p-3">
                        {user.teamsId || user.tenantId ? "YES" : "NO"}
                      </td>
                      <td className="p-3">{user.code ? "YES" : "NO"}</td>
                      <td className="p-3">{user.code}</td>
                      <td className="p-3">{notificationType(user)}</td>
                      <td className="p-3">
                        {(user.createdDate || "")?.slice(0, 10)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        per_page={filter.limit}
        total={total}
        onNext={() => setFilter((prev) => ({ ...prev, page: prev.page + 1 }))}
        onPrevious={() =>
          setFilter((prev) => ({ ...prev, page: prev.page - 1 }))
        }
        currentPage={filter.page}
      />
    </div>
  );
};

function notificationType(user) {
  const types = [];
  if (user.mailNotification) types.push("Email");
  if (user.pushNotification) types.push("Push");
  if (user.otherMailNotifications) types.push("Other");
  return types.join(", ");
}
